import { AntiSpamFields } from "../../../interfaces/main";
import { axiosInstance } from "../axiosConfig";

export default async function loginUser(
  email: string,
  password: string,
  antiSpamPayload?: AntiSpamFields
) {
  try {
    const { data } = await axiosInstance.post("/login", {
      email: email,
      password: password,
      ...antiSpamPayload,
    });
    return data;
  } catch (err) {
    throw err;
  }
}
